import { useMediaQuery } from "./use-media-query";

/**
 * Hook to detect if the current viewport is mobile-sized
 *
 * Uses mobile-first approach: returns true for screens < 768px
 *
 * @returns Boolean indicating if the viewport is mobile-sized
 *
 * @example
 * ```tsx
 * const isMobile = useIsMobile();
 *
 * return (
 *   <div>
 *     {isMobile ? <MobileNav /> : <DesktopNav />}
 *   </div>
 * );
 * ```
 *
 * @remarks
 * - Breakpoint: 768px (matches Tailwind's `md` breakpoint)
 * - Uses `useMediaQuery` hook internally with debouncing
 * - Maintains backward compatibility with existing code
 */
export function useIsMobile(): boolean {
  // Mobile-first: true for screens < 768px (max-width: 767px)
  // This is equivalent to "not (min-width: 768px)"
  return useMediaQuery("(max-width: 767px)");
}
